import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useStaticQuery, graphql } from "gatsby";

const NavBar = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        sections
      }
    }
  `).dataYaml;

  const sections = data.sections.map(section => (
    <Link
      activeClassName="active"
      className="nav-link navItem"
      to={section === "about" ? "/" : `/${section}`}
    >
      {section}
    </Link>
  ));

  return (
    <Navbar sticky="top" bg="dark" variant="dark" expand="lg">
      <Navbar.Brand href="/">Rouzbeh Majidi</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">{sections}</Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
